import { checkAuth } from './auth';
import {
    PROFILE_SITES_SUCCESS,
    PROFILE_SITES_REQUEST,
    DELETE_SITE_REQUEST,
    DELETE_SITE_SUCCESS,
    CONFIG_DOMAIN_REQUEST,
    CONFIG_DOMAIN_SUCCESS,
    CONFIG_DOMAIN_FAILURE,
    DELETE_SITE_FAILURE,
    DUPLICATE_SITE_REQUEST,
    DUPLICATE_SITE_SUCCESS,
    SAVE_SITE_REQUEST,
    SAVE_SITE_SUCCESS,
    SAVE_SITE_FAILURE,
    SET_BUILDING_ID,
    SET_SITE_SAVED_STATUS,
    FETCH_SITE_REQUEST,
    FETCH_SITE_SUCCESS,
    FETCH_SITE_FAILURE,
    SITE_CLEAR_MESSAGE,
    EXPORT_FILES_REQUEST,
    EXPORT_JSON_REQUEST,
} from '../actionTypes';
import makeActionCreator from './makeActionCreator';

export function requestSites(accessToken) {
    return checkAuth({ accessToken, type: PROFILE_SITES_REQUEST });
}

export function receivedSites(payload) {
    return { type: PROFILE_SITES_SUCCESS, payload };
}

export const setBuildingId = (id) => ({
    id,
    type: SET_BUILDING_ID,
});

export const saveSite = (payload) =>
    checkAuth({
        payload,
        type: SAVE_SITE_REQUEST,
    });

export const saveSiteSuccess = (payload) => ({
    payload,
    type: SAVE_SITE_SUCCESS,
});

export const saveSiteFailure = (payload) => ({
    payload,
    type: SAVE_SITE_FAILURE,
});

export const deleteSite = (siteId) =>
    checkAuth({
        siteId,
        type: DELETE_SITE_REQUEST,
    });

export function deleteSiteSuccess(siteId) {
    return {
        siteId,
        type: DELETE_SITE_SUCCESS,
    };
}

export function deleteSiteFailure(errorMessage) {
    return {
        errorMessage,
        type: DELETE_SITE_FAILURE,
    };
}

export const configDomain = (payload) =>
    checkAuth({
        payload,
        type: CONFIG_DOMAIN_REQUEST,
    });

export function configDomainFails(errorMessage) {
    return {
        errorMessage,
        type: CONFIG_DOMAIN_FAILURE,
    };
}

export function configDomainSuccess(payload) {
    return {
        payload,
        type: CONFIG_DOMAIN_SUCCESS,
    };
}

export const duplicateSite = (siteId) =>
    checkAuth({
        siteId,
        type: DUPLICATE_SITE_REQUEST,
    });

export const duplicateSiteSuccess = (siteId, payload) => ({
    siteId,
    payload,
    type: DUPLICATE_SITE_SUCCESS,
});

export const setSavedStatus = (status) => ({
    status,
    type: SET_SITE_SAVED_STATUS,
});

export const fetchSite = (siteId, pageId) =>
    checkAuth({
        siteId,
        pageId,
        type: FETCH_SITE_REQUEST,
    });

export const fetchSiteSuccess = (payload) => ({
    payload,
    type: FETCH_SITE_SUCCESS,
});

export const fetchSiteFailure = (payload) => ({
    payload,
    type: FETCH_SITE_FAILURE,
});

export const clearSiteMessage = makeActionCreator(SITE_CLEAR_MESSAGE);

export const exportFiles = (siteId) =>
    checkAuth({ type: EXPORT_FILES_REQUEST, siteId });

export const exportJSON = (siteId) =>
    checkAuth({ type: EXPORT_JSON_REQUEST, siteId });
